import { render, staticRenderFns } from "./MaterielsItemVerif.vue?vue&type=template&id=6952e59a&"
import script from "./MaterielsItemVerif.vue?vue&type=script&lang=js&"
export * from "./MaterielsItemVerif.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports